export default __webpack_public_path__ + "static/media/automatskavrata4.614ed222.png";